import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Box, IconButton, Menu, Tooltip, Typography } from '@material-ui/core';

import PhotoSizeSelectSmallIcon from '@material-ui/icons/PhotoSizeSelectSmall';
import PinDropIcon from '@material-ui/icons/PinDrop';
import { Skeleton } from '@material-ui/lab';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import SiteSelectorMenuItem from './SiteSelectorMenuItem';
import TenureChip from './TenureChip';
import OverflowTypography from '../../../../Common/UI/OverflowTypography';

class SiteSelector extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        currentPolygonId: PropTypes.number,
        currentPolygonIds: PropTypes.arrayOf(PropTypes.number),
        polygons: PropTypes.object,
        titles: PropTypes.object,
        onCurrentPolygonIdChanged: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            anchorEl: null
        };

        this.root = React.createRef();

        this.handleMenuOpen = this.handleMenuOpen.bind(this);
        this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
        this.handleMenuClose = this.handleMenuClose.bind(this);
        this.sortParcels = this.sortParcels.bind(this);
    }

    handleMenuOpen (event) {
        this.setState({ anchorEl: this.root.current });
    }

    handleMenuItemClick (polygonId) {
        const { onCurrentPolygonIdChanged } = this.props;
        this.setState({ anchorEl: null });
        onCurrentPolygonIdChanged(polygonId);
    }

    handleMenuClose () {
        this.setState({ anchorEl: null });
    }

    sortParcels (x, y) {
        // Sort by tenure, then alphabetically by address
        const { titles } = this.props;
        const titleX = titles[x.titleNo];
        const titleY = titles[y.titleNo];
        const tenures = ['Freehold', 'Leasehold', 'Unregistered', 'Unknown'];
        const tenureIndexValue = tenures.findIndex(e => e === titleX.tenureAgg) - tenures.findIndex(e => e === titleY.tenureAgg);
        if (tenureIndexValue !== 0) {
            return tenureIndexValue;
        }
        if (titleX.address < titleY.address) return -1;
        if (titleX.address > titleY.address) return 1;
        return 0;
    }

    render () {
        const { classes, currentPolygonId, currentPolygonIds, polygons, titles } =this.props;
        const { anchorEl } = this.state;

        const currentPolygon = polygons[currentPolygonId];
        const isLoading = !currentPolygonId || currentPolygonIds.some(id => !polygons[id] || polygons[id].isLite || polygons[id].isFetchingPolygon);

        if (isLoading) { return <Skeleton animation="wave" height={128} variant="rect" />; }

        const currentTitleNo = currentPolygon.titleNo;
        const currentTitle = titles[currentTitleNo];

        const orderedPolygons = currentPolygonIds
            .map(polygonId => polygons[polygonId])
            .sort(this.sortParcels);

        const currentPolygonIdIndex = orderedPolygons.findIndex(polygon => polygon.polygonId === currentPolygonId);

        const what3words = 'placeholder.placeholder.placeholder';

        return (
            <div className={classes.siteInformationContainer}>
                <div ref={this.root}>
                    <div className={classes.siteInformationInfoContainer}>
                        <div className={classes.siteInformationMultiple}>
                            <PhotoSizeSelectSmallIcon />
                            <Typography>{`${currentPolygonIdIndex + 1}/${currentPolygonIds.length}`}</Typography>
                        </div>
                        <Box overflow="hidden">
                            <TenureChip tenure={currentTitle.tenureAgg} />
                            <OverflowTypography className={classes.address}>{currentTitle.address}</OverflowTypography>
                            <div>
                                <Typography className={classes.tenureChip}>{currentTitle.tenure.classOfTitle}</Typography>
                                <Typography className={classes.tenureChip}>{currentTitle.tenure.estateInterest}</Typography>
                            </div>
                        </Box>
                        {
                            currentPolygonIds.length > 1 &&
                                <IconButton
                                    className={classes.selectorButton}
                                    onClick={this.handleMenuOpen}
                                >
                                    <ArrowDropDownIcon />
                                </IconButton>
                        }
                    </div>
                </div>
                <Menu
                    classes={{ paper: classes.menuList }}
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={this.handleMenuClose}
                    disableAutoFocusItem
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}
                    PaperProps={{
                        style: { width: anchorEl ? anchorEl.clientWidth + 2: 0 }
                    }}
                >
                    {
                        orderedPolygons
                            .filter(polygon => polygon.polygonId !== currentPolygonId)
                            .map(polygon => {
                                const title = titles[polygon.titleNo];
                                return (
                                    <SiteSelectorMenuItem
                                        key={title.titleNo}
                                        tenure={title.tenureAgg}
                                        polygonId={polygon.polygonId}
                                        titleNo={title.titleNo}
                                        address={title.address}
                                        onClicked={this.handleMenuItemClick}
                                    />
                                ); 
})
                    }
                </Menu>
                <div className={classes.siteInformationInnerContainer}>
                    {/* <Typography className={classes.siteInformationInner} variant="caption"> */}
                    {/*    <span>UPRN</span> */}
                    {/*    &nbsp; */}
                    {/*    <span>TO BE REPLACED</span> */}
                    {/* </Typography> */}
                    <Typography className={classes.siteInformationInner} variant="caption">
                        <PinDropIcon />
                        &nbsp;
                        <span>{currentTitle.centroid.coordinates.map(e => e.toFixed(6)).join(', ')}</span>
                    </Typography>
                    {/* <Typography className={classes.siteInformationInner} variant="caption"> */}
                    {/*    <span>///</span> */}
                    {/*    &nbsp; */}
                    {/*    <Tooltip arrow title={what3words} placement={"bottom"}> */}
                    {/*        <span>{what3words}</span> */}
                    {/*    </Tooltip> */}
                    {/* </Typography> */}
                </div>
            </div>
        );
    }
}

const style = theme => ({
    menuList: {
        backgroundColor: theme.palette.background.main,
        border: `1px solid ${theme.palette.background.border}`,
        borderRadius: '0px 0px 5px 5px',
        boxSizing: 'border-box',
        '&> ul': {
            padding: 0
        },
        ...theme.components.scrollable
    },
    selectorButton: {
        color: theme.palette.icon.main,
        marginLeft: 'auto'
    },
    siteInformationContainer: {
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${theme.palette.background.border}`,
        borderRadius: '5px',
        position: 'relative'
    },
    siteInformationInfoContainer: { fontWeight: 500,
        fontSize: '11px',
        display: 'flex',
        padding: '15px'
    },
    siteInformationMultiple: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 20px',
        marginRight: '15px',
        color: theme.palette.text.primary,
        '&> p': {
            fontSize: '14px',
            fontWeight: 'bold'
        }
    },
    siteInformationInnerContainer: {
        display: 'flex'
    },
    siteInformationInner: {
        flex: '1 1 0',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        borderTop: `1px solid ${theme.palette.background.border}`,
        '&:not(:last-child)': {
            borderRight: `1px solid ${theme.palette.background.border}`
        },
        padding: `${theme.constants.verticalMargin * 0.5}px ${theme.constants.horizontalMargin}px`,
        '&> *:first-child': {
            fontWeight: 500,
            color: theme.palette.text.primary
        },
        '&> svg:first-child': {
            fontSize: '1.2em'
        },
        '&> *:last-child': {
            color: theme.palette.text.secondary,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    address: {
        ...theme.typography.body1,
        color: theme.palette.text.primary,
        lineHeight: '16px',
        height: '16px',
        margin: '10px 0px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    tenureChip: {
        ...theme.typography.chip,
        display: 'inline-flex',
        color: theme.palette.secondary.light,
        background: `${theme.palette.secondary.light}33`,
        marginRight: '12px',
        padding: '0px 6px'
    }
});

export default withStyles(style)(SiteSelector);